import React from "react";
import "./ReferFrndBanner.scss";
import RewardCoinImage from "../../../../utilities/images/refer&earn/rewardCoin.png";
import referYourFrnd from "../../../../utilities/images/refer&earn/referYourFrnd.png";

const ReferFrndBanner = ({ data }) => {
  return (
    <div className="referFrndBannerWrppr">
      <div className="referyourFrdsBanner">
        <div className="content">
          <div className="left">
            <div className="rewardCoins">
              <img src={RewardCoinImage} alt="rewardCoin" />
              <span>Total Reward of {data.motion_coins} Motion Coins</span>
            </div>
            <div className="ReferYourFrndsText">Refer your friends</div>
            <p className="EarnCoinsEachPara">Earn 500 Motion Coins each</p>
          </div>
          <div className="right">
            <div className="img">
              <img src={referYourFrnd} alt="referYourFrnd" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferFrndBanner;
